export const HdpSingle = `
{{var esportsLogoURL = data.esportsLogoURL || '';}}
{{var period = parseInt(data.period);}}
{{var isSelectedPeriod = period > 0;}}
{{var firstPeriod = isSelectedPeriod ? period : 0;}}
{{var event_count = 0;}}
{{var options = data.options;}}
{{? data.sports}}
{{var isMultipleSports = data.sports.length > 1;}}
{{~data.sports :sp:sp_index}}
{{var isSoccerType = sp[4] === SportGroup.SOCCER;}}
{{? isMultipleSports}}<div class="mul-sp-name"><span><li class="sp {{=utils.convertToSportIcon(sp[1])}} sp{{=sp[0]}}"></li></span>{{=i18n('sports', sp[1])}}</div>{{?}}
{{var ot = data.ot;}}
{{var isParlay = (data.isParlay || data.isParlayMarket);}}
{{var isEsport = sp[0] == 12;}}
{{var isSoccer = sp[0] == 29;}}
{{var sportName = sp[1];}}
{{var isShowLiveTv = data.isShowLiveTv;}}
{{var isEnableSignUp = data.isEnableSignUp;}}
{{var isBlockedLiveSport = data.isBlockedLiveSport;}}
{{var blockedLiveLeagues = data.blockedLiveLeagues;}}
{{var periodsRightLayout = data.periodsRightLayout;}}
{{var isBrandSupportLiveCenter = data.isBrandSupportLiveCenter;}}
{{var altMainLabel = data.altMainLabel && (isSelectedPeriod ? Number(firstPeriod) !== 1 : periodsRightLayout[0] !== 1) ? (data.altMainLabel + "_".concat(isSelectedPeriod ? firstPeriod : periodsRightLayout[0])) : "";}}
{{var periodsDescription = data.periodsDescription;}}
{{var isTennis = sp[0] == 33;}}
{{var isShowPeriodName = data.isShowPeriodName;}}

<div class='single-line {{? data.favourite}} fav-container {{?}} {{? isMultipleSports}} mul-sp {{?}}'>
    <div class="freeze-table-header"></div>
    <table class="events events-header{{? options.isParlayMarket}} isParlayMarket{{?}} sp{{=sp[0]}}">
        <tr>
            <td class="col-icons main-icons border-left border-bottom col-border-left"></td>
            <td class="col-time main-time border-bottom-right">{{=i18n('Time')}}</td>
            <td class='col-fav main-fav border-bottom'>&nbsp</td>
            <td class='col-name main-name border-bottom-right'><span>{{=i18n('Event')}}</span></td>
            {{? isEsport}}
                <td class="hdp main-hdp border-bottom-right">{{=i18n('others', 'e_HDP')}}</td>
                <td class="odds main-odds border-bottom-right">{{=i18n('Team 1')}}</td>
                <td class="odds main-odds border-bottom-right">{{=i18n('Team 2')}}</td>
                <td class="hdp main-hdp border-bottom-right">{{=i18n('others', 'TTL')}}</td>
                <td class="odds main-odds border-bottom-right">{{=i18n('Over')}}</td>
                <td class="odds main-odds border-bottom-right">{{=i18n('Under')}}</td>
                {{? isSelectedPeriod}}
                    <td class="hdp main-hdp border-bottom-right"> &nbsp </td>
                    <td class="odds main-odds border-bottom-right"> &nbsp </td>
                    <td class="odds main-odds border-bottom-right"> &nbsp </td>
                    <td class="hdp main-hdp border-bottom-right"> &nbsp </td>
                    <td class="odds main-odds border-bottom-right"> &nbsp </td>
                    <td class="odds main-odds border-bottom-right"> &nbsp </td>
                {{??}}
                    <td class="hdp main-hdp border-bottom-right">
                        <div>{{=i18n('M1.HDP')}}</div>
                    </td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Team 1')}}</td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Team 2')}}</td>
                    <td class="hdp main-hdp border-bottom-right">
                        <div>{{=i18n('M2.HDP')}}</div>
                    </td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Team 1')}}</td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Team 2')}}</td>
                {{?}}
            {{??}}
                {{? isSelectedPeriod}}
                  <td class="hdp main-hdp border-bottom-right">{{=getPeriodsName(periodsDescription, sp[0], period, true)}} HDP</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Home')}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Away')}}</td>
                  <td class="hdp main-hdp border-bottom-right">{{=getPeriodsName(periodsDescription, sp[0], period, true)}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Over')}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Under')}}</td>

                  <td class="hdp main-hdp border-bottom-right"> &nbsp </td>
                  <td class="odds main-odds border-bottom-right"> &nbsp </td>
                  <td class="odds main-odds border-bottom-right"> &nbsp </td>
                  <td class="hdp main-hdp border-bottom-right"> &nbsp </td>
                  <td class="odds main-odds border-bottom-right"> &nbsp </td>
                  <td class="odds main-odds border-bottom-right"> &nbsp </td>
                {{??}}
                  <td class="hdp main-hdp border-bottom-right">{{=i18n('HDP' + altMainLabel)}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Home')}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Away')}}</td>
                  <td class="hdp main-hdp border-bottom-right">{{=i18n('Goal' + altMainLabel)}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Over')}}</td>
                  <td class="odds main-odds border-bottom-right">{{=i18n('Under')}}</td>
                  {{~ periodsRightLayout :p:p_index}}
                    <td class="hdp main-hdp border-bottom-right"><span class="period-hdp">{{=getPeriodsName(periodsDescription, sp[0], p, true)}}</span> <span>{{=i18n('HDP')}}</span></td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Home')}}</td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Away')}}</td>
                    <td class="hdp main-hdp border-bottom-right"><span class="period-hdp">{{=getPeriodsName(periodsDescription, sp[0], p, true)}}</span> <span>{{=i18n('Goal')}}</span></td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Over')}}</td>
                    <td class="odds main-odds border-bottom-right">{{=i18n('Under')}}</td>
                  {{~}}
                {{?}}
            {{?}}
            <td class="col-more main-more border-bottom-right border-left col-border-right" title="{{=i18n('More')}}">&nbsp;</td>
        </tr>
    </table>
    {{var leagues = sp[2];}}
    {{var images = {};}}
    {{~leagues :lg:lg_index}}
    {{var leagueName = lg[1];}}
    {{var leagueId = lg[0];}}
    {{var isBlockedLiveLeague = blockedLiveLeagues.indexOf(leagueId) > -1;}}
    <div class="league" id='lg{{=leagueId}}'>
        <a class="bookmark "><i data-league-id="{{=leagueId}}" class='fav  icon'></i></a>
        <div class="fav-custom-tooltip ">
            <div class="tooltip-wrapper">
                <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
            </div>
        </div>
        <span>
        {{var originalLeagueName = lg[4] ? lg[4] : leagueName;}}
        {{? isEsport && originalLeagueName}}
            {{var category = originalLeagueName.indexOf('-') > -1 ? originalLeagueName.split('-')[0].trim() : '';}}
            {{var code = category.toLowerCase().replaceAll(' ', '').replaceAll(':', '');}}
            {{var url = esportsLogoURL.concat(code, '/league/', leagueId, '.png');}}
            {{var gameUrl = '';}}
            {{ var clazzName = 'i'.concat(leagueId);}}
            {{
                images[leagueId] = new Image();
                images[leagueId].dataset.id = leagueId;
                images[leagueId].onload = function() {
                    var dotImgOrEmpty = (this.width == 1 && this.height == 1) || (this.width == 0 && this.height == 0);
                    var className = 'sport-icon icon-default ';
                    var el = document.getElementsByClassName('i'.concat(this.dataset.id));
                    if (!dotImgOrEmpty) {                        
                        if (el.length == 1) {
                        el[0].style.backgroundImage  =  'url(' + this.src + ')';
                        } else if (el.length > 1) {
                            for (var i=0; i < el.length; i++) {
                                el[i].style.backgroundImage  =  'url(' + this.src + ')';
                            }
                        }
                    } else {                
                        if (el.length == 1) {
                            el[0].className  =  className + 'icon-' + this.code;
                        } else if (el.length > 1) {
                            for (var i=0; i < el.length; i++) {
                                el[i].className  = className + 'icon-' + this.code;
                            }
                        }
                    }
                };
                images[leagueId].onerror = function() {   
                    var className = 'sport-icon icon-default ';
                    var el = document.getElementsByClassName('i'.concat(this.dataset.id));
                    if (el.length == 1) {
                        el[0].className  =  className + 'icon-' + this.code;
                    } else if (el.length > 1) {
                        for (var i=0; i < el.length; i++) {
                            el[i].className  = className + 'icon-' + this.code;
                        }
                    }
                      
                };
                images[leagueId].src = url;
                images[leagueId].code = code;
            }}
            <div class="league-icon {{=clazzName}}">
            </div>
        {{?}}
        {{=leagueName}}
        </span>
        <a class="refresh-odds" data-live="{{=data.isLive}}"><i class='icon refresh-odds'></i></a>
    </div>
    <div>
    {{~lg[2] :ev:ev_index}}
    {{var periodsEv = fetchOddsByPeriods(sp[0], period, periodsRightLayout, ev) || [];}}
    {{var listPeriods = Object.keys(ev[8]) || [];}}
    {{var filterNewPeriod = listPeriods.filter(function(period) { return parseInt(period) !== 0 && !periodsRightLayout.includes(parseInt(period));});}}
    {{var countRowSpan = countRowSpanMoreBet(sp[0], filterNewPeriod, ev, isEsport, data.maxLines, period, true, periodsRightLayout) || 1;}}
    {{var numLineCenter  = Math.round(countRowSpan/2);}}

    <table class="events no-select events-list single-mode sp{{=sp[0]}} {{=isParlay?'parlay':''}} border-bottom" id="e{{=ev[0]}}">
        {{var event_count = event_count + 1;}}
        {{var _moreBetsCount = countMoreBetSingleLine(sp[0], ev, isParlay);}}
        {{var isExtraTime = isSoccer && listPeriods.some(function(period) {return parseInt(period) === 3});}}
        {{var isScoreExtraTime = RunningStateExtraTime.includes(ev[16]);}}
        {{var countLineOdds = 0;}}
        {{~periodsEv :pe:pe_index}}
            {{var ft = isSelectedPeriod ? ev[8][period] : [];}}
            {{var leftSide = pe[0], rightSide = pe[1];}}
            {{var periodNewLine = leftSide >= 0 ? leftSide : rightSide[0];}}
            {{? leftSide >= 0}}
                {{ft = leftSide > 0 ? ev[8][leftSide] : ev[8][0];}}
            {{?}}
            {{var [homeRedCard, awayRedCard] = getRedCard(ev[10], ft, leftSide, isScoreExtraTime) || [0, 0];}}
            {{var isLineParent = period > 0 ? leftSide === period : leftSide === 0;}}
            {{var haftTimePeriods = {};}}
            {{~rightSide :p:p_index}}
            {{? ev[8][p]}}
                {{haftTimePeriods["ht" + p] = ev[8][p];}}
            {{?}}
            {{~}}

            {{var ht = haftTimePeriods[Object.keys(haftTimePeriods)[rightSide]];}}
            {{var ht2 = haftTimePeriods[Object.keys(haftTimePeriods)[2]];}}
            {{var ht3 = haftTimePeriods[Object.keys(haftTimePeriods)[3]];}}

            {{var minLine = ev[3] > 0 ? Math.min(ev[3], data.maxLines) : data.maxLines;}}
            {{var ftHDP =  ft && ft[0] || [];}}
            {{var ftOU = ft && ft[1] || [];}}
            {{var ftML =  ft && ft[2] || [];}}

            {{var haftTimeLines = {};}}
            {{~Object.keys(haftTimePeriods) :htKey:ht_index}}
            {{haftTimeLines[htKey + "HDP"] = (haftTimePeriods[htKey][0] || []);}}
            {{haftTimeLines[htKey + "OU"] = (haftTimePeriods[htKey][1] || []);}}
            {{~}}

            {{var htHDP = haftTimeLines["ht" + rightSide[0] + "HDP"] || [];}}
            {{var htOU = haftTimeLines["ht" + rightSide[0] + "OU"] || [];}}
            {{var htHDP2 = haftTimeLines["ht" + rightSide[1] + "HDP"] || [];}}

            {{var isDisplayMarket = leftSide >= 0 || (ftHDP.length > 0 || ftOU.length > 0 || htHDP.length > 0 || htOU.length > 0); }}
            {{var indexMainLineFtHDP = ft && ft[7]&& ft[7][0] || 0;}}
            {{var indexMainLineFtOU = ft && ft[7] && ft[7][1] || 0;}}
            {{var indexMainLineHtHDP = ht && ht[7] && ht[7][0] || 0;}}
            {{var indexMainLineHtOU = ht && ht[7] && ht[7][1] || 0;}}
            {{var indexMainLineHtHDP2 = ht2 && ht2[7] && ht2[7][0] || 0;}}
            {{var indexMainLine = Math.max(indexMainLineFtHDP, indexMainLineFtOU, indexMainLineHtHDP, indexMainLineHtOU, indexMainLineHtHDP2, 0);}}
            
            <!--Calculate the _moreBetsCount value when sport is eSport -->
            {{? isEsport}}
                {{var numberOfDisplayedLine = Math.min(isSelectedPeriod ? Math.max(ftHDP.length, ftOU.length) : Math.max(ftHDP.length, ftOU.length, htHDP.length, htHDP2.length), data.maxLines) || 1;}}
            {{??}}
                {{var numberOfDisplayedLine = Math.min(isSelectedPeriod ? Math.max(ftHDP.length, ftOU.length) : Math.max(ftHDP.length, ftOU.length, htHDP.length, htOU.length), data.maxLines) || 1;}}
            {{?}}
            
            {{var lines = new Array().init(Math.min(minLine, data.maxLines, numberOfDisplayedLine));}}
            {{var statusPeriodLeftSide = (ft && ft[11]) ? "status_" + ft[11] : "";}}
            {{var statusPeriodRightSide = (ht && ht[11]) ? "status_" + ht[11] : "";}}
            {{var statusPeriod2ndRightSide = (ht2 && ht2[11]) ? "status_" + ht2[11] : "";}}
            {{~lines :line:line_index}}

            {{var _fthdp = ftHDP.length > (line - (indexMainLine - indexMainLineFtHDP)) && (line - (indexMainLine - indexMainLineFtHDP)) >= 0 && ftHDP[line - (indexMainLine - indexMainLineFtHDP)];}}
            {{var isFTHDPOnline = _fthdp && _fthdp[2] != '';}}
            
            {{var _ftou = ftOU.length > (line - (indexMainLine - indexMainLineFtOU)) && (line - (indexMainLine - indexMainLineFtOU)) >= 0 && ftOU[line - (indexMainLine - indexMainLineFtOU)];}}
            {{var isFTOUOnline = _ftou && _ftou[0] != '';}}
            
            {{var _hthdp = htHDP.length > (line - (indexMainLine - indexMainLineHtHDP)) && (line - (indexMainLine - indexMainLineHtHDP)) >= 0 && htHDP[line - (indexMainLine - indexMainLineHtHDP)];}}
            {{var isHTHDPOnline = _hthdp && _hthdp[2] != '';}}

            {{var _htou = htOU.length > (line - (indexMainLine - indexMainLineHtOU)) && (line - (indexMainLine - indexMainLineHtOU)) >= 0 && htOU[line - (indexMainLine - indexMainLineHtOU)];}}
            {{var isHTOUOnline = _htou && _htou[0] != '';}}
            
            {{var _hthdp2 = htHDP2.length > (line - (indexMainLine - indexMainLineHtHDP2)) && (line - (indexMainLine - indexMainLineHtHDP2)) >= 0 && htHDP2[line - (indexMainLine - indexMainLineHtHDP2)];}}
            {{var isHTHDP2Online = _hthdp2 && _hthdp2[2] != '';}}
            
            {{var isMainLine = (line == indexMainLine);}}
            {{countLineOdds = countLineOdds + (isDisplayMarket ? 1 : 0);}}
            {{var isShowMoreBet = periodsEv && periodsEv.length > 1 ? numLineCenter === countLineOdds : isMainLine;}}
            {{var numberLine = (!isMainLine && line_index == 0) || lines.length >= 2 ? lines.length : 1;}}
            {{? isEsport}}
                {{var isValidPeriod = _fthdp || _ftou || _hthdp || _hthdp2;}}
            {{??}}
                {{var isValidPeriod = _fthdp || _ftou || _hthdp || _htou || ftML;}}
            {{?}}
            {{? (isValidPeriod || line === 0) && isDisplayMarket}}
            <tr class='{{=event_count%2==0?"even":"odd"}} main-mkline e{{=ev[0]}}' id="e{{=ev[0]}}_{{=_fthdp[8]}}" {{? _moreBetsCount > 0}} data-eid="{{=ev[0]}}" {{?}} >
                <td class='col-icons main-icons border-left col-border-left'>
                </td>
                {{?line_index == 0}}
                <td class='col-time main-time border-right' rowspan='{{=numberLine}}'>
                    {{? isLineParent}}
                        {{? ev[5]}}
                            {{? isExtraTime || !isScoreExtraTime}}
                                {{? ev[9]}}
                                    <span>{{=ev[9][0]}}-{{=ev[9][1]}}</span>
                                {{??}}
                                    {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                                {{?}}
                            {{?}}
                            {{? !isExtraTime || !isScoreExtraTime}}
                                {{? ev[16]}}
                                    <span class='liveInfo'>{{=i18n(ev[16])}} {{=ev[15]||''}}</span>
                                {{??}}
                                    <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                                {{?}}
                            {{?}}
                        {{??}}
                            {{? ev[6] && !isBlockedLiveSport && !isBlockedLiveLeague}}
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                                {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                            {{??}}
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n('MM/DD'))}}</span>
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                            {{?}}
                        {{?}}
                    {{?}}
                    {{? isScoreExtraTime && isExtraTime && leftSide === 3}}
                        {{? ft[9]}}<span>{{=ft[9][0]}}-{{=ft[9][1]}}</span>{{?}}
                        {{? ev[16]}}
                            <span class='liveInfo'>{{=i18n(ev[16])}} {{=ev[15]||''}}</span>
                        {{?}}
                    {{?}}
                </td>
                {{?}}
                <td class='col-fav main-fav'>
                    {{? isMainLine && isLineParent}}
                    <a class="bookmark" data-event-id="{{=ev[0]}}"><i class='fav  icon'></i></a>
                    <div class="fav-custom-tooltip ">
                        <div class="tooltip-wrapper">
                            <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
                        </div>
                    </div>
                    {{?}}
                </td>
                <td class='{{=_fthdp&&(_fthdp[6]||_fthdp[5])? "": "no-underdog"}} col-name main-name border-right {{=ev[18] && ev[19] ? "lc-icons": ev[19] ? "live-tv": ev[18] ?  "live-c" : ""  }}'
                    data-live="{{=ev[20]}}"
                    data-event="{{=ev[0]}}"
                    data-league-id="{{=leagueId}}"
                    data-home-team="{{=ev[1]}}"
                    data-away-team="{{=ev[2]}}"
                    data-sport-name="{{=sportName}}"
                >
                    {{? isMainLine}}
                        {{? isTennis && !ev[29] && ev[27] && ev[27].toLowerCase() != 'regular' }}
                            <div class="grading-unit-container">
                                ({{=i18n(ev[27])}})
                            </div>
                        {{?}}
                        {{? isShowPeriodName && periodNewLine !== 0 && periodNewLine !== 1 }}
                            <div class='period-description {{=(homeRedCard || awayRedCard) ? "space-red-card" : ""}}'>
                                ({{=getPeriodsName(periodsDescription, sp[0], periodNewLine, false)}})
                            </div>
                        {{?}}
                        <div class="team-name-container">
                            <span class='{{=_fthdp && _fthdp[5] ? "favSel": "sel"}}' title="{{=ev[1]}}">
                                {{? isEsport}}
                                    {{var homeName = ev[24].toLowerCase().replaceAll(' ', '_');}}
                                    {{var url = esportsLogoURL.concat(code, '/team/', homeName, '.png');}}
                                    <span class="logo"><img class="sport-icon" src='{{=url}}' onerror="this.style.display='none'"/></span>
                                {{?}}
                                {{? homeRedCard}}
                                    <div class="card-container">
                                        <i class="card redCard">{{=homeRedCard}}&lrm;</i>
                                    </div>
                                {{?}}
                                {{=ev[1]}}
                            </span>
                            <span class='{{=_fthdp && _fthdp[6] ? "favSel": "sel"}}' title="{{=ev[2]}}">
                                {{? isEsport}}
                                    {{var awayName = ev[25].toLowerCase().replaceAll(' ', '_');}}
                                    {{var url = esportsLogoURL.concat(code, '/team/', awayName, '.png');}}
                                    <span class="logo"><img class="sport-icon" src='{{=url}}' onerror="this.style.display='none'"/></span>
                                {{?}}
                                {{? awayRedCard}}
                                    <div class="card-container">
                                        <i class="card redCard">{{=awayRedCard}}&lrm;</i>
                                    </div>
                                {{?}}
                                {{=ev[2]}}
                            </span>
                        </div>
                    {{??}}
                        <span>&nbsp;</span><span>&nbsp;</span>
                    {{?}}
                </td>
                <td class='hdp main-hdp hdp-border border-right {{=statusPeriodLeftSide}}' data-period="{{=leftSide}}">
                    <span class='hdp'>{{=isFTHDPOnline ? _fthdp[2].formatSeparators() : '&nbsp;'}}</span>
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-period="{{=leftSide}}">
                    {{? isFTHDPOnline}}
                    <a class="odds {{=_fthdp[3] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_fthdp[7]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][0]}}"
                    id="{{=ev[0]}}|{{=leftSide}}|2|0|{{=_fthdp[8]?1:0}}|{{=_fthdp[1]}}">
                    {{? ot === OddsFormat.American}}
                            <span>{{? _fthdp[3] > 0}}+{{?}}{{=_fthdp[3]}}</span>
                        {{??}}
                            <span>{{=_fthdp[3].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}&nbsp;
                    {{?}}
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-period="{{=leftSide}}">
                    {{? isFTHDPOnline}}
                    <a class="odds {{=_fthdp[4] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_fthdp[7]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][1]}}"
                    id="{{=ev[0]}}|{{=leftSide}}|2|1|{{=_fthdp[8]?1:0}}|{{=_fthdp[0]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _fthdp[4] > 0}}+{{?}}{{=_fthdp[4]}}</span>
                        {{??}}
                            <span>{{=_fthdp[4].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}&nbsp;
                    {{?}}
                </td>
                <td class='hdp main-hdp hdp-border border-right {{=statusPeriodLeftSide}}' data-period="{{=leftSide}}">
                    <span>{{=isFTOUOnline ? _ftou[0].formatSeparators(): '&nbsp;'}}</span>
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-period="{{=leftSide}}">
                    {{? isFTOUOnline}}
                    <a class="odds {{=_ftou[2] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_ftou[4]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][0]}}"
                    id="{{=ev[0]}}|{{=leftSide}}|3|3|{{=_ftou[5]?1:0}}|{{=_ftou[1]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _ftou[2] > 0}}+{{?}}{{=_ftou[2]}}</span>
                        {{??}}
                            <span>{{=_ftou[2].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}
                    &nbsp;
                    {{?}}
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-period="{{=leftSide}}">
                    {{? isFTOUOnline}}
                    <a class="odds {{=_ftou[3] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_ftou[4]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][1]}}"
                    id="{{=ev[0]}}|{{=leftSide}}|3|4|{{=_ftou[5]?1:0}}|{{=_ftou[1]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _ftou[3] > 0}}+{{?}}{{=_ftou[3]}}</span>
                        {{??}}
                            <span>{{=_ftou[3].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}
                    &nbsp;
                    {{?}}
                </td>
                {{? isSelectedPeriod}}
                    <td class='hdp main-hdp hdp-border'> &nbsp </td>
                    <td class='odds main-odds'> &nbsp </td>
                    <td class='odds main-odds border-left'> &nbsp </td>
                    <td class='hdp main-hdp hdp-border'> &nbsp </td>
                    <td class='odds main-odds'> &nbsp </td>
                    <td class='odds main-odds border-left'> &nbsp </td>
                {{??}}
                    <td class='hdp main-hdp hdp-border border-right {{=statusPeriodRightSide}}' data-period="{{=rightSide[0]}}">
                        <span class='hdp'>{{=isHTHDPOnline ? _hthdp[2].formatSeparators() : '&nbsp;'}}</span>
                    </td>
                    <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-period="{{=rightSide[0]}}">
                        {{? isHTHDPOnline}}
                        <a class="odds {{=_hthdp[3] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=_hthdp[7]}}"
                        data-date="{{=ev[4]}}"
                        data-pl-res="{{=ev[22]}}"
                        data-team-type="{{=ev[11][0]}}"
                        id="{{=ev[0]}}|{{=rightSide[0]}}|2|0|{{=_hthdp[8]?1:0}}|{{=_hthdp[1]}}"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? _hthdp[3] > 0}}+{{?}}{{=_hthdp[3]}}</span>
                            {{??}}
                                <span>{{=_hthdp[3].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-period="{{=rightSide[0]}}">
                        {{? isHTHDPOnline}}
                        <a class="odds {{=_hthdp[4] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=_hthdp[7]}}"
                        data-date="{{=ev[4]}}"
                        data-pl-res="{{=ev[22]}}"
                        data-team-type="{{=ev[11][1]}}"
                        id="{{=ev[0]}}|{{=rightSide[0]}}|2|1|{{=_hthdp[8]?1:0}}|{{=_hthdp[0]}}"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? _hthdp[4] > 0}}+{{?}}{{=_hthdp[4]}}</span>
                            {{??}}
                                <span>{{=_hthdp[4].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    {{? isEsport}} <!-- Add the Map 2 hdp values when sport is eSport -->
                        <td class='hdp main-hdp hdp-border border-right {{=statusPeriod2ndRightSide}}' data-period="{{=rightSide[1]}}">
                            <span class='hdp'>{{=isHTHDP2Online ? _hthdp2[2].formatSeparators() : '&nbsp;'}}</span>
                        </td>
                        <td class="odds main-odds border-right {{=statusPeriod2ndRightSide}}" data-period="{{=rightSide[1]}}">
                            {{? isHTHDP2Online}}
                            <a class="odds {{=_hthdp2[3] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_hthdp2[7]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][0]}}"
                            id="{{=ev[0]}}|{{=rightSide[1]}}|2|0|{{=_hthdp2[8]?1:0}}|{{=_hthdp2[1]}}"
                            >
                                {{? ot === OddsFormat.American}}
                                    <span>{{? _hthdp2[3] > 0}}+{{?}}{{=_hthdp2[3]}}</span>
                                {{??}}
                                    <span>{{=_hthdp2[3].formatSeparators()}}</span>
                                {{?}}
                            </a>
                            {{??}}&nbsp;
                            {{?}}
                        </td>
                        <td class="odds main-odds border-right {{=statusPeriod2ndRightSide}}" data-period="{{=rightSide[1]}}">
                            {{? isHTHDP2Online}}
                            <a class="odds {{=_hthdp2[4] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_hthdp2[7]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][1]}}"
                            id="{{=ev[0]}}|{{=rightSide[1]}}|2|1|{{=_hthdp2[8]?1:0}}|{{=_hthdp2[0]}}"
                            >
                                {{? ot === OddsFormat.American}}
                                    <span>{{? _hthdp2[4] > 0}}+{{?}}{{=_hthdp2[4]}}</span>
                                {{??}}
                                    <span>{{=_hthdp2[4].formatSeparators()}}</span>
                                {{?}}
                            </a>
                            {{??}}&nbsp;
                            {{?}}
                        </td>
                    {{??}}
                        <td class='hdp main-hdp hdp-border border-right {{=statusPeriodRightSide}}' data-period="{{=rightSide[0]}}">
                            <span>{{=isHTOUOnline ? _htou[0].formatSeparators(): '&nbsp;'}}</span>
                        </td>
                        <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-period="{{=rightSide[0]}}">
                            {{? isHTOUOnline}}
                            <a class="odds {{=_htou[2] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_htou[4]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][0]}}"
                            id="{{=ev[0]}}|{{=rightSide[0]}}|3|3|{{=_htou[5]?1:0}}|{{=_htou[1]}}"
                            >
                                {{? ot === OddsFormat.American}}
                                    <span>{{? _htou[2] > 0}}+{{?}}{{=_htou[2].formatSeparators()}}</span>
                                {{??}}
                                    <span>{{=_htou[2].formatSeparators()}}</span>
                                {{?}}
                            </a>
                            {{??}}
                            &nbsp;
                            {{?}}
                        </td>
                        <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-period="{{=rightSide[0]}}">
                            {{? isHTOUOnline}}
                            <a class="odds {{=_htou[3] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_htou[4]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][1]}}"
                            id="{{=ev[0]}}|{{=rightSide[0]}}|3|4|{{=_htou[5]?1:0}}|{{=_htou[1]}}"
                            >
                                {{? ot === OddsFormat.American}}
                                    <span>{{? _htou[3] > 0}}+{{?}}{{=_htou[3]}}</span>
                                {{??}}
                                    <span>{{=_htou[3].formatSeparators()}}</span>
                                {{?}}
                            </a>
                            {{??}}
                            &nbsp;
                            {{?}}
                        </td>
                    {{?}}
                {{?}}
                <td class='col-more main-more border-right col-border-right'>
                {{? isShowMoreBet}}
                    <div class='more-content'>
                        {{? ev[31] }}
                            {{? isShowLiveTv && ev[19] && !isBlockedLiveSport && !isBlockedLiveLeague }} 
                                <!-- Has live tv -->
                                <span class="icons live-tv-icon">
                                    <i class="live-tv"
                                    data-live="{{=ev[20]}}"
                                    data-event="{{=ev[0]}}"
                                    data-league-id="{{=leagueId}}"
                                    data-home-team="{{=ev[1]}}"
                                    data-away-team="{{=ev[2]}}"
                                    data-sport-name="{{=sportName}}"
                                    >
                                    </i>
                                    <div class="custom-tooltip">
                                    <div class="tooltip-wrapper">
                                        <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                        <span class="tooltip-text">{{=i18n('to access our Live TV')}}</span>
                                    </div>
                                    </div>
                                </span>
                            {{?}}
                            <!-- Has stats -->
                            <span class="icons stats-icon">
                                <i class="stats"
                                data-live="{{=ev[20]}}"
                                data-event="{{=ev[0]}}"
                                data-league-id="{{=leagueId}}"
                                data-home-team="{{=ev[1]}}"
                                data-away-team="{{=ev[2]}}"
                                data-sport-name="{{=sportName}}"
                                data-league-name="{{=leagueName}}"
                                >
                                </i>
                            </span>
                        {{??}}
                            {{? !isBlockedLiveSport && !isBlockedLiveLeague}}
                                {{? ev[18] && isBrandSupportLiveCenter}}
                                    <!-- Has live center -->
                                    <span class="icons live-center-icon">
                                        <i class="live-ct"
                                        data-live="{{=ev[20]}}"
                                        data-event="{{=ev[0]}}"
                                        data-league-id="{{=leagueId}}"
                                        data-home-team="{{=ev[1]}}"
                                        data-away-team="{{=ev[2]}}"
                                        data-sport-name="{{=sportName}}"
                                        data-league-name="{{=leagueName}}"
                                        >
                                        </i>
                                        <div class="custom-tooltip">
                                        <div class="tooltip-wrapper">
                                            <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                            {{? isEnableSignUp}}
                                            <span class="tooltip-text">{{=i18n('or')}}</span>
                                            <a id="{{=TooltipActions.SIGNUP}}" class="tooltip-link">{{=i18n('Sign up')}}</a>
                                            {{?}}
                                            <span class="tooltip-text">{{=i18n('to access our Live Center')}}</span>
                                        </div>
                                        </div>
                                    </span>
                                {{?}}
                                {{? isShowLiveTv && ev[19] }} 
                                    <!-- Has live tv -->
                                    <span class="icons live-tv-icon">
                                        <i class="live-tv"
                                        data-live="{{=ev[20]}}"
                                        data-event="{{=ev[0]}}"
                                        data-league-id="{{=leagueId}}"
                                        data-home-team="{{=ev[1]}}"
                                        data-away-team="{{=ev[2]}}"
                                        data-sport-name="{{=sportName}}"
                                        >
                                        </i>
                                        <div class="custom-tooltip">
                                        <div class="tooltip-wrapper">
                                            <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                            <span class="tooltip-text">{{=i18n('to access our Live TV')}}</span>
                                        </div>
                                        </div>
                                    </span>
                                {{?}}
                            {{?}}
                        {{?}}
                        {{? _moreBetsCount > 0}}
                            {{var originalLeagueName = lg[4] ? lg[4] : leagueName;}}
                            <span id='more_{{=ev[0]}}' class='more' data-eid="{{=ev[0]}}" data-league-name="{{=originalLeagueName}}">
                                <span class='sign'>+</span>
                                <span class="more-count">
                                    {{=_moreBetsCount}}
                                </span>
                            </span>
                        {{?}}
                    </div>
                {{?}}  
                </td>
            </tr>
            {{?}}
            {{~}}
        {{~}}
        <tr class="more-bets {{=event_count%2==0?"even":"odd"}}" id="e{{=ev[0]}}_more"><td colspan="17" class="more-bets"></td></tr>
        </table>
        {{~}}<!--Events-->
        </div>
        {{~}}<!--Leagues-->
        {{? leagues.length ==0}}
            <div class="no-event">{{=i18n('No Events')}}</div>
        {{?}}
    </div>
    {{~}}<!--Sports-->
{{?}}
`;


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/HdpSingle.js